<template>
  <div>
    <label for="checkbox" :id="`${name}_label`">
      {{ facet_label }}
      <input type="checkbox" :id="`${name}_checkbox`" :value="selected" v-model="selected"/>
    </label>
  </div>
</template>

<script>
import mixins from 'common/mixins.js'
import { mapState, mapMutations } from 'vuex'

export default {
  props: ['name', 'values', 'operator', 'sign', 'facet'],
  mixins: [mixins.internationalization],
  data() {
    return {
      selected: this.getSelected()
    }
  },
  computed: {
    facet_label() {
      var label = this.get_label(this.name)
      return label != '' ? label : this.facet.name
    },
    boolean_class() {
      return this.selected ? 'inactive' : 'active'
    },
    ...mapState("search", ['specialFilter'])
  },
  methods: {
    ...mapMutations("search", ['changeSpecialFilter']),
    getSelected() {
      if (this.specialFilter == 'true') {
        return true
      } else if (this.values.includes('true')) {
        this.changeSpecialFilter()
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    selected(new_value, old_value) {
      this.$emit('update_filter', this.name, new_value ? ['true'] : [], this.facet.default_operator)
    },
    values(new_value, old_value) {
      if (new_value.length < old_value.length) {
        this.selected = false
      }
    }
  }
}

</script>